import React, {useEffect, useState} from "react";
import "./MyMahi.scss"
import {useNavigate, useParams} from "react-router-dom";
import {RouteParam} from "../../types/types";
import {MyMahiViewModel} from "../../viewmodel/mymahi/MyMahiViewModel";
import {MyMahiStatusType} from "../../domain/verification/MyMahiStatusType";
import {HeaderComponent} from "../../components/common/header/HeaderComponent";
import {ReactComponent as MyMahiIcon} from '../../assets/icons/mymahi.svg';

export const MyMahiPage: React.FC = () => {
    const { verificationId } = useParams<RouteParam>();
    const {
        retrieveVerificationStatus,
        retrieveVerificationUrl,
        cancelVerificationRequest,
        url,
        status
    } = MyMahiViewModel()
    const navigate = useNavigate();

    const [retrieveInterval, setRetrieveInterval] = useState<NodeJS.Timer>()

    useEffect(() => {
        if (verificationId) {
            retrieveVerificationUrl(verificationId)
            const interval = setInterval(async () => {
                await retrieveVerificationStatus(verificationId)
            }, 2000)
            setRetrieveInterval(interval)
        }
    }, [retrieveVerificationUrl, retrieveVerificationStatus, verificationId]);

    useEffect(() => {
        if (status !== MyMahiStatusType.PENDING.toLowerCase()) {
            if (status === MyMahiStatusType.CANCELLED.toLowerCase()) {
                navigate(`/${verificationId}/document`)
            } else {
                localStorage.removeItem("next-step")
                navigate(`/${verificationId}/consent`)
            }
            clearInterval(retrieveInterval)
        }
    }, [retrieveInterval, verificationId, navigate, status]);


    const navigateBack = async () => {
        if (verificationId) {
            await cancelVerificationRequest(verificationId)
            clearInterval(retrieveInterval)
            navigate(`/${verificationId}/document`)
        }
    }

    return (
        <div className={`background background-white general-container`}>
            <HeaderComponent logo back onBackClick={navigateBack}/>
            <div className={`flex-center mymahi-container`}>
                <div className={`flex-center width-full`}>
                    <div className={`flex-center mymahi-icon-container`}>
                        <MyMahiIcon/>
                    </div>
                </div>
                <div className={`flex-center mymahi-text-container`}>
                    <div className={`flex-center primary-color font-lg mymahi-text-title`}>MyMahi digital student ID</div>
                    <div className={`flex-center primary-color mymahi-text-message font-md font-400`}>To continue, please allow access to MyMahi</div>
                    <div className={`flex-center primary-color mymahi-text-message font-md font-400`}>in the browser/app we opened.</div>
                    {url && <a href={url} target='_blank' rel='noreferrer' className={`flex-center primary-color mymahi-link font-md`}>Click here to open MyMahi</a>}
                </div>
                <div className={`flex-center mymahi-status-container`}>
                    Checking with MyMahi...
                </div>
            </div>
        </div>
    )
}
